const DefaultCharLimit = 20

const truncateString = (
	string: string,
	charLimit = DefaultCharLimit
): string => {
	return string.length > charLimit
		? string.slice(0, charLimit - 1).trim() + '...'
		: string
}

export default truncateString
